import styled from 'styled-components';

export const ShiftTypeFilterContainer = styled.div`
    margin: 0;
    min-width: 0;
`;

export const ShiftTypeFilterRow = styled.div`
    min-height: 30px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0 0.125rem;

    .shiftTypePrefix {
        flex: 0 0 auto;
        color: var(--text-secondary, #3F4755);
        font-size: 0.875rem;
        font-weight: 600;
        margin-right: 0.125rem;
    }

    .MuiFormControlLabel-root {
        min-width: 0;
        margin: 0;
    }

    .MuiFormControlLabel-label {
        color: var(--text-primary, #05132E);
        font-family: var(--fontMain, Poppins), sans-serif;
        font-size: 0.875rem;
        font-weight: 500;
        white-space: nowrap;
    }

    .lockedLabel {
        display: inline-flex;
        align-items: center;
    }

    .lockIcon {
        color: var(--text-secondary, #6D6D72);
        font-size: 0.875rem;
        margin-left: 0.125rem;
    }

    .MuiCheckbox-root {
        color: #0B4598;
        padding: 5px;
    }

    @media (max-width: 380px) {
        .MuiFormControlLabel-label,
        .shiftTypePrefix {
            font-size: 0.6875rem;
        }
    }
`;

export const ShiftTypeHint = styled.div`
    color: var(--text-secondary, #516173);
    font-size: 0.75rem;
    line-height: 1.2;
    padding: 0.25rem 0 0.375rem;
`;
